import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BillingTabs = ({ activeTab, onTabChange, onGenerateInvoice, onProcessPayment, onSendReminder }) => {
  const tabs = [
    {
      id: 'per-card',
      label: 'Per-Card Billing',
      icon: 'CreditCard',
      count: 156
    },
    {
      id: 'per-user',
      label: 'Per-User Billing',
      icon: 'User',
      count: 89
    },
    {
      id: 'team-billing',
      label: 'Team Billing',
      icon: 'Users',
      count: 24
    }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg">
      {/* Tab Headers */}
      <div className="flex items-center justify-between border-b border-border p-4">
        <div className="flex space-x-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                activeTab === tab.id
                  ? 'bg-accent text-accent-foreground'
                  : 'text-text-secondary hover:text-text-primary hover:bg-hover'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span>{tab.label}</span>
              <span className={`px-2 py-0.5 rounded-full text-xs ${
                activeTab === tab.id
                  ? 'bg-accent-foreground/20 text-accent-foreground'
                  : 'bg-text-muted/20 text-text-muted'
              }`}>
                {tab.count}
              </span>
            </button>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            iconName="FileText"
            iconPosition="left"
            onClick={onGenerateInvoice}
          >
            Generate Invoice
          </Button>
          <Button
            variant="primary"
            iconName="CreditCard"
            iconPosition="left"
            onClick={onProcessPayment}
          >
            Process Payment
          </Button>
          <Button
            variant="ghost"
            iconName="Send"
            iconPosition="left"
            onClick={onSendReminder}
          >
            Send Reminder
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BillingTabs;